<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{ routeName }}</a>
      <button class="navbar-toggler navbar-burger" type="button" @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar" aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="#" class="nav-link" @click="addCategory()">
              <i class="ti-plus"></i>
              <p>Ajouter une catégorie</p>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link">
              <span>
                <i class="ti-bell"></i>
                <span style="
                      background-color: rgb(210, 200, 100);
                      width: 25px;
                      height: 25px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    " class="badge badge-pill text-primary rounded-circle">5
                </span>
              </span>
            </a>
          </li> -->


        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    addCategory() {
      this.$router.push("/add-category");
    },
  },
};
</script>
<style></style>
